import React, { useEffect, useState, Component } from 'react';
export function LandingTest() {
  const [checkoutUrl, setCheckoutUrl] = useState('https://legendaryreads.com/cart/42364926459986:1?checkout');
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    let clickId = urlParams.get('click_id');
    if (!clickId) {
      try {
        clickId = sessionStorage.getItem('cf_click_id') || localStorage.getItem('cf_click_id');
      } catch (e) {}
    } else {
      try {
        sessionStorage.setItem('cf_click_id', clickId);
        localStorage.setItem('cf_click_id', clickId);
      } catch (e) {}
    }
    if (clickId) {
      const base = 'https://legendaryreads.com/cart/42364926459986:1';
      setCheckoutUrl(base + '?click_id=' + encodeURIComponent(clickId) + '&checkout');
    }
  }, []);
  return <div className="min-h-screen bg-[#0B0B0B] flex items-center justify-center p-4" data-id="element-962">
      <div className="w-full max-w-md" data-id="element-963">
        <a href={checkoutUrl} className="block w-full py-6 px-8 text-center text-xl font-bold rounded-xl transition-all duration-300 transform active:scale-[0.98] shadow-[0_0_30px_rgba(255,108,0,0.3)] hover:shadow-[0_0_50px_rgba(255,108,0,0.5)] hover:brightness-110 no-underline" style={{
        background: 'linear-gradient(90deg, #FFD300 0%, #FF6C00 100%)',
        color: '#0B0B0B',
        fontFamily: 'Inter, sans-serif'
      }} data-id="element-964">
          COMPLETE MY ORDER →
        </a>
      </div>
    </div>;
}